<template>
    <v-dialog v-model="$store.state.paperworkAnalytics.PpwEmail" fullscreen transition="dialog-transition">
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>Paperwork Email</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.paperworkAnalytics.PpwEmail = false;"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-iterator :items="Shifts" :page="page" :items-per-page="perpage" hide-default-footer
                    style="height: 550px;overflow: auto;">
                    <template v-slot:default="props">
                        <v-container grid-list-xs v-for="(itm, id) in props.items" v-bind:key="'Shift' + id" fluid>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Shift</th>
                                        <th>Region</th>
                                        <th>Truck</th>
                                        <th>Trailer</th>
                                        <th>Yard</th>
                                        <th>DriverName</th>
                                        <th>Email</th>
                                        <th>Send</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ itm.Date }}</td>
                                        <td>{{ itm.Shift }}</td>
                                        <td>{{ itm.PrincipalRegion }}</td>
                                        <td>{{ itm.Truck }}</td>
                                        <td>{{ itm.Trailer }}</td>
                                        <td>{{ itm.Yard }}</td>
                                        <td>{{ itm.DriverName }}</td>
                                        <td>{{ itm.PrintEmail }}</td>
                                        <td>
                                            <v-badge color="green" overlap :content="itm.mails" :value="itm.mails != 0"
                                                offset-x="16" offset-y="12">
                                                <v-btn color="secondary" @click="sendMissingEmail(itm)"
                                                    style="float: right;" small class="mr-2">Send <v-icon small
                                                        class="my-auto ml-3">mdi-send</v-icon></v-btn>
                                            </v-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="background: white;" colspan="1"></td>
                                        <td style="background: #bbd5f9;">OrderID</td>
                                        <td style="background: #bbd5f9;">OrderStatus</td>
                                        <td style="background: #bbd5f9;">LoadNum</td>
                                        <td style="background: #bbd5f9;">LoadNumOrd</td>
                                        <td style="background: #bbd5f9;">BillOfLading</td>
                                        <td style="background: #bbd5f9;" colspan="3">Action Reason</td>
                                    </tr>
                                    <tr v-for="(ord, idx) in itm.orders" v-bind:key="'ord' + idx">
                                        <td style="background: white;" colspan="1"></td>
                                        <td style="background: #dceafc;">{{ ord.OrderID }}</td>
                                        <td style="background: #dceafc;">{{ ord.OrderStatus }}</td>
                                        <td style="background: #dceafc;">{{ ord.LoadNum }}</td>
                                        <td style="background: #dceafc;">{{ ord.LoadNumOrd }}</td>
                                        <td style="background: #dceafc;">{{ ord.BillOfLading }}</td>
                                        <td style="background: #dceafc;" colspan="3">
                                            <template v-for="(res, i) in ord.actions">
                                                {{ (i + 1) + '.- ' + (res.Action === 'ER - Missing Geofence' ? '' : res.Action ) }}.
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-container>
                    </template>
                </v-data-iterator>
                <v-row justify="end">
                    <v-col cols="1">
                        <v-btn color="primary" large icon
                            @click="prevPage"><v-icon>mdi-arrow-left-drop-circle-outline</v-icon></v-btn>
                        <v-btn color="primary" large icon
                            @click="nextPage"><v-icon>mdi-arrow-right-drop-circle-outline</v-icon></v-btn></v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
    props: ['parms'],
    data: function () {
        return {
            count: 1,
            page: 1,
            perpage: 3,
            Shifts: []
        }
    },
    mounted() {
        this.getEmailByColorLoads();
        // console.log(this.parms);
    },
    computed: {
        numberOfPages() {
            return Math.ceil(this.Shifts.length / 3);
        },
        filteredKeys() {
            return this.keys.filter(key => key !== 'Name');
        }
    },
    methods: {
        nextPage: function () {
            if (this.page < this.numberOfPages) {
                this.page++;
                console.log(this.page);
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                console.log(this.page);
            }
        },
        getEmailByColorLoads: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios.post('shift-detail/eleos/by/status', this.parms, {
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            })
                .then(response => {
                    this.Shifts = response.data;
                    this.Shifts.forEach(x => {
                     const rpl = x.Email.replace(";", ",");
                     x.PrintEmail = rpl;
                     
                     const splt = x.Email.split(";");
                     x.Email = splt;
                    });
                    console.log(this.Shifts);
                    
            str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
            str.state.isLoading = false;
                });
        },
        searchData: function (miss) {
            var pivot = [];
            miss.orders.forEach(element => {
                element.actions.forEach(action => {
                    console.log(action.pivot.ActionId);
                    if (action.pivot.ActionId == 9) {
                        pivot.push(1);
                    } else if (action.pivot.ActionId == 1 || action.pivot.ActionId == 4 || action.pivot.ActionId == 29) {
                        pivot.push(2);
                    }
                    else if (action.pivot.ActionId == 28) {
                        pivot.push(4);
                    }
                    else if (action.pivot.ActionId == 22 || action.pivot.ActionId == 18 || action.pivot.ActionId == 2 ||
                        action.pivot.ActionId == 3 || action.pivot.ActionId == 16 || action.pivot.ActionId == 26 || action.pivot.ActionId == 23) {
                        pivot.push(3);
                    }else if(action.pivot.ActionId == 21 || action.pivot.ActionId == 33 || action.pivot.ActionId == 34 || action.pivot.ActionId == 30 
                    || action.pivot.ActionId == 31 || action.pivot.ActionId == 5){
                        pivot.push(6);
                    } 
                    else if(action.pivot.ActionId == 36){
                        pivot.push(7);
                    } else {
                        pivot.push(5);
                    }
                });
            });
            console.log(pivot);
            return this.eliminarDuplicados(pivot);
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        sendMissingEmail: async function (miss) {
            var vla = await this.searchData(miss);
            var str = this.$store;
            await   vla.forEach(element => {
                if(element != 6){
                    
                str.state.isLoading = true;
                    var parms = {
                    Type: element, //1 = Action Type :9 //2 = Action Type :1,4,29 // 3 = Action Type :22,18,2,3,16,26,23 // Action Type 6 : 26 // 5 Else
                    missing: miss,
                    SendDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                }
                axios
                    .post('shift-detail/send/missing/email', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        miss.mails++;
                        str.dispatch('setSnackbar', {
                                color: 'success',
                                text: 'Mail sent successfully'
                            });
                        console.log(response.data);
                        str.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.state.isLoading = false;
                    });
                }
            });

        }
    }
}
</script>